import { render, staticRenderFns } from "./MatchTracker.vue?vue&type=template&id=58c245d0&scoped=true"
import script from "./MatchTracker.vue?vue&type=script&lang=js"
export * from "./MatchTracker.vue?vue&type=script&lang=js"
import style0 from "./MatchTracker.vue?vue&type=style&index=0&id=58c245d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c245d0",
  null
  
)

export default component.exports